import React from 'react';
import AsyncSmb from './index';
import {Route} from 'react-router-dom';

export default [
  <Route
    key="/business/solutions/online-service/campaign"
    path="business/solutions/online-service/campaign"
    element={<AsyncSmb />}
  />,
];
